<template>
  <div class="push-records">
    <ContentBlock>
      <TableWithPagination class="special" :columnList="columnList" :tableData="targetLists" :mergeCells="mergeCells" :toolBar="toolBar" :sortInfo.sync="sortInfo" tableBorder="default" :showRightToolbar="true" :pagination.sync="pagination" @size-change="getTargetLists" @current-change="getTargetLists" @sort-change="getTargetLists" :highHoverRow="false" :highlightRow="false" :leftToolbar="tableButtons" />
    </ContentBlock>
    <el-drawer title="高级筛选" width="400" direction="rtl" :modal-append-to-body="false" :visible.sync="isShow"
      :close-on-click-modal="false" @closed="isShow = false">
      <el-form label-width="auto" label-position="right" style="margin-top: 20px;padding: 10px;">
        <el-row>
          <el-col :span='24'>
            <el-form-item label="商机号">
              <el-input placeholder="请输入商机号" v-model.trim="form.bizOppCode" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="商机标题">
              <el-input placeholder="请输入商机标题" v-model.trim="form.bizOppTitle" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="商机分类">
              <cascaderForNicheCaterory ref="cascaderForNicheCateroryRef" checkStrictly @handleSelect="handleSelectCategory" />
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="商机品牌">
              <el-select
                v-model="form.bizOppBrandName"
                filterable
                remote
                reserve-keyword
                placeholder="请输入品牌名称或简称"
                :remote-method="remoteMethodBrand"
                :loading="loadingBrand"
                clearable>
                <el-option
                  v-for="(item, index) in brandList"
                  :key="'brand-'+index"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="供应商名称">
              <el-input placeholder="请输入供应商名称" v-model.trim="form.tenantName" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="推送时间">
              <el-date-picker
                v-model="sendTime"
                @change="handleChangeTime($event, 'sendTime')"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span='24'>
            <el-form-item label="推送状态">
              <el-select v-model.trim="form.status" placeholder="请选择推送状态" clearable
                :popper-append-to-body="false">
                <el-option label="全部" value=""></el-option>
                <el-option label="成功" :value="1"></el-option>
                <el-option label="失败" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align: center;">
        <el-button @click="handleEmpty">清空</el-button>
        <el-button type="primary" @click="handleQuery">查询</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import TableWithPagination, { TablePaginationMixin } from '@/components/common/TableWithPagination';
import { getBizOppSendRecordPageList, exportTenantBizOppWechatMsgSendRecord } from '@/api/niche';
import * as dayjs from 'dayjs';
import icRefresh from '@/assets/table/ic_refresh.svg';
import icAdvanceSearch from '@/assets/table/ic_advanceSearch.svg';
import cascaderForNicheCaterory from '@/components/cascaderForNicheCaterory';
import { getBrandLists } from '@/api/PlatformSales/Brand';

export default {
  name: 'SASS_GXTGL_BUSINESSOPPORTUNITY',
  components: {
    TableWithPagination,
    cascaderForNicheCaterory,
  },
  mixins: [TablePaginationMixin],
  computed: {
    tableButtons () {
      return [
        {
          name: '导出',
          status: 'primary',
          size: 'small',
          code: 'exportExcel',
          disabled: this.isLoading,
          loading: this.isLoading,
          // permission: '', // 权限码
          click: this.handleExport,
        },
        {
          type: 'custom',
          render: () => {
            let updateTime = '';
            const hour = dayjs().format('HH');
            const now = dayjs().format('YYYY-MM-DD') + ' 08:00:00';
            // 如果当前时间在8点之前，更新时间为前一天8点整
            if (hour < 8) {
              updateTime = dayjs().subtract(1, 'day').format('YYYY-MM-DD') + ' 08:00:00';
            } else {
              updateTime = now;
            }
            return (
              <span style='margin-left:10px;'>
                更新时间：{updateTime}
              </span>
            );
          },
        },
      ];
    },
    toolBar () {
      let currentLists = [
        {
          type: 'custom',
          render: () => {
            return (
              <el-input placeholder='请输入商机标题' style='width:250px;' v-model={this.form.bizOppTitle}>
                <el-button slot="suffix" icon="el-icon-search" onClick={this.handleSearch} style='position: absolute;height: 100%;right: -5px;top: 0;'>
                </el-button>
              </el-input>
            );
          },
        },
        {
          type: 'custom',
          render: () => {
            return (
              <vxe-button circle onClick={this.handleAdvancedSearch}>
                <img style='font-size:14px;width:15px;height:15px;' src={icAdvanceSearch} />
              </vxe-button>
            );
          },
        },
        {
          type: 'custom',
          render: () => {
            return (
              <vxe-button circle onClick={this.handleReset}>
                <img style='font-size:14px;width:15px;height:15px;' src={icRefresh} />
              </vxe-button>
            );
          },
        },
      ];
      return currentLists;
    },
    columnList () {
      const cols = [
        {
          tooltip: true,
          label: '商机号',
          minWidth: '',
          width: '120px',
          key: 'bizOppCode',
          prop: 'bizOppCode',
        },
        {
          tooltip: true,
          label: '商机标题',
          minWidth: '150px',
          width: '',
          key: 'bizOppTitle',
          prop: 'bizOppTitle',
        },
        {
          tooltip: true,
          label: '商机分类',
          minWidth: '200px',
          width: '',
          key: 'bizOppCategoryName',
          prop: 'bizOppCategoryName',
        },
        {
          tooltip: true,
          label: '商机品牌',
          minWidth: '120px',
          width: '',
          key: 'bizOppBrandName',
          prop: 'bizOppBrandName',
        },
        {
          tooltip: true,
          label: '用户名称',
          minWidth: '120px',
          width: '',
          key: 'tenantName',
          prop: 'tenantName',
        },
        {
          tooltip: true,
          label: '推送时间',
          minWidth: '',
          width: '140px',
          key: 'sendTime',
          prop: 'sendTime',
          format: (v) => {
            return this.formatTime(v);
          },
        },
        {
          tooltip: true,
          label: '推送状态',
          minWidth: '',
          width: '80px',
          key: 'status',
          prop: 'status',
          slots: {
            default: ({ row }, h) => {
              let result = [];
              if ([1, '1'].includes(row.status)) {
                result.push((
                  <span>成功</span>
                ));
              }
              if ([2, '2'].includes(row.status)) {
                result.push((
                  <el-tooltip content={row.failureCause || '--'} placement="top-start">
                    <div>
                      <span>失败</span>
                      <span class="el-icon-info" style="margin-left:5px;font-size:14px;"></span>
                    </div>
                  </el-tooltip>
                ));
              }
              return [h('div', result)];
            },
          },
        },
      ];
      return cols;
    },
  },
  data () {
    return {
      form: {
        bizOppCode: '',
        bizOppTitle: '',
        bizOppCategoryId: '',
        bizOppBrandName: '',
        tenantName: '',
        sendTimeEnd: '',
        sendTimeStart: '',
        status: '',
      },
      sendTime: '',
      targetLists: [],
      mergeCells: [],
      isShow: false,
      isLoading: false,
      brandList: [],
      loadingBrand: false,
    };
  },
  methods: {
    formatTime (v) {
      let ret = '';

      if (v) {
        ret = dayjs(v * 1).format('YYYY-MM-DD HH:mm');
      }

      return ret;
    },
    handleSelectCategory (v) {
      const categoryId = v.value.slice(-1)[0];
      this.form.bizOppCategoryId = categoryId;
    },
    remoteMethodBrand (query) {
      if (query !== '') {
        this.loadingBrand = true;
        this.queryBrandList(query);
      } else {
        this.brandList = [];
      }
    },
    handleChangeTime (v, type) {
      if (!v || v.length === 0) {
        this.form[type + 'Start'] = '';
        this.form[type + 'End'] = '';
      } else {
        this.form[type + 'Start'] = v[0] + ' 00:00:00';
        this.form[type + 'End'] = v[1] + ' 23:59:59';
      }
    },
    handleQuery () {
      this.pagination.currentPage = 1;

      this.getTargetLists();

      this.$nextTick(() => {
        this.isShow = false;
      });
    },
    handleSearch () {
      this.pagination.currentPage = 1;

      this.getTargetLists();
    },
    handleAdvancedSearch () {
      this.isShow = true;
    },
    handleReset () {
      this.handleEmpty();

      this.pagination.currentPage = 1;

      this.getTargetLists();
    },
    handleEmpty () {
      this.form = this.$options.data().form;
      this.sendTime = [];
      if (this.$refs.cascaderForNicheCateroryRef) {
        this.$refs.cascaderForNicheCateroryRef.defaultValue = [];
      }
    },
    handleExport () {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      const params = {
        ...this.form,
        sendTimeStart: new Date(this.form.sendTimeStart || '').getTime() || '',
        sendTimeEnd: new Date(this.form.sendTimeEnd || '').getTime() || '',
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.currentPage,
      };
      if (this.sortInfo.orderByProperty && this.sortInfo.orderByType) {
        params.orderBy = [this.sortInfo];
      }
      exportTenantBizOppWechatMsgSendRecord(params).then(res => {
        this.isLoading = false;
        let headerName = `商机推送记录表_${dayjs().format('YYYYMMDDHHmmss')}`;
        let fileName = decodeURI(headerName);
        let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'}); // 注意你的文件类型，我的是excel，需要什么类型文件，对应修改即可
        // IE兼容
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
          var a = document.createElement('a');
          a.download = fileName;
          a.href = URL.createObjectURL(blob);
          a.setAttribute('id', 'export');
          document.body.appendChild(a); // 修复firefox中无法触发click， platform 为我本页div 的id， 此处可直接用document.body
          a.click();
          document.getElementById('export').remove();
        }
      }).then(() => {
        this.isLoading = false;
      });
    },
    getTargetLists () {
      const params = {
        ...this.form,
        sendTimeStart: new Date(this.form.sendTimeStart || '').getTime() || '',
        sendTimeEnd: new Date(this.form.sendTimeEnd || '').getTime() || '',
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };

      if (this.sortInfo.orderByProperty && this.sortInfo.orderByType) {
        params.orderBy = [this.sortInfo];
      }

      getBizOppSendRecordPageList(params).then(({ body }) => {
        this.pagination.total = Number(body?.total || 0);

        let targetLists = [];
        (body?.list || []).map(item => {
          if (item.tenantRecordList?.length > 0) {
            item.tenantRecordList.map((record, index) => {
              targetLists.push({
                ...item,
                ...record,
                lengths: item.tenantRecordList?.length,
                id: `${item.id}-${index}`,
              });
            });
          }
        });
        this.targetLists = targetLists;

        this.mergeCells = this.calculateMergeCells();
      });
    },
    // 动态计算合并单元格配置
    calculateMergeCells () {
      const mergeCells = [];
      let rowIndex = 0;
      const fieldToCol = {
        '商机号': 0,
        '商机标题': 1,
        '商机分类': 2,
        '商机品牌': 3,
      };
      const colIndices = Object.values(fieldToCol);

      while (rowIndex < this.targetLists.length) {
        const currentBizOppId = this.targetLists[rowIndex].bizOppId;
        // 统计当前商机id的连续行数
        let groupRow = 1;
        while (rowIndex + groupRow < this.targetLists.length && this.targetLists[rowIndex + groupRow].bizOppId === currentBizOppId) {
          groupRow++;
        }
        // 为当前分组的列添加合并配置
        colIndices.forEach(col => {
          mergeCells.push({
            row: rowIndex,
            col: col,
            rowspan: groupRow,
            colspan: 1,
          });
        });
        rowIndex += groupRow;
      }
      return mergeCells;
    },
    async queryBrandList (query = '') {
      const { body } = await getBrandLists({
        enableFlag: true,
        nameOrShortName: query,
        pageNum: 1,
        pageSize: 30,
      });
      this.loadingBrand = false;
      this.brandList = body?.list || [];
    },
  },
  created () {
    this.handleSearch();
    this.queryBrandList();
  },
};
</script>
<style scoped lang='scss'>
.title-box {
  color: #303133;
  font-weight: 600;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .icon-box {
    display: flex;
    align-items: center;

    img {
      margin-right: 8px;

      &:hover {
        cursor: pointer;
      }
    }

    i {
      &:hover {
        cursor: pointer;
      }
    }
  }
}

/deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #409EFF;
  border-color: #409EFF;
}

/deep/.vxe-tools--wrapper {
  display: flex;
  justify-content: space-between;

  &>.el-button {
    margin-left: 0.5em;
  }

  &>div.el-input {
    margin-left: 0.5em;
  }

  &>.vxe-button {
    margin-left: 0.5em;
  }
}

/deep/ .vxe-tools--operate {
  &>.vxe-button {
    margin-left: 0.5em;
  }
}

/deep/ .action {
  color: #409EFF;
  cursor: pointer;

  &:hover {
    color: rgba(64, 158, 255, 0.7);
    text-decoration: underline;
  }
}

/deep/ .el-date-editor.el-input {
  width: -webkit-fill-available;
}
</style>
